import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { SearchService } from "./search.service";
import { environment } from "../../environments/environment";
import * as _ from "underscore";
import * as $ from "jquery";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"],
  providers: [SearchService]
})
export class SearchComponent implements OnInit {
  @Input() products;
  @Input() asrtHeaderHeight;
  @Input() listId;
  @Input() appliedFilter;
  @Output("searchProduct") searchProduct = new EventEmitter();

  private availableProductNames = [];
  private availableProductIds = [];
  private filteredProductIds = [];
  private filteredProductNames = [];
  private selectedProductIdx = null;
  private isSearchHidden = true;
  private bgOpacity = false;
  private isSearchListHidden = true;
  private inputSearchValue = "";
  private hideForMobile = true;
  private searchConfiguredFields = [];
  public ENV = environment;

  constructor(private searchService: SearchService) {}

  ngOnInit() {
    this.getProductNames();
  }

  getProductNames() {
    this.availableProductNames = [];
    for (let asrt of this.products.assortments) {
      let asrtName = asrt.name;
      for (let coll of asrt.collections) {
        for (let item of coll.items) {
          if (item.colors) {
            for (let color of item.colors) {
              this.availableProductIds.push(color.id + " - " + asrtName);
            }
          }
          if (item.name) {
            this.availableProductNames.push(item.name + " - " + asrtName);
          }
        }
      }
    }
  }
  isNumeric(value) {
    if (!value) {
      return false;
    }
    let test = value.split("-");
    if (
      (test[0] && this.isNumeric(this.chopFirstChar(test[0]))) ||
      (test[1] && this.isNumeric(test[1]))
    ) {
      return true;
    }
    let tesval = test[0].trim();
    return /^-{0,1}\d+$/.test(tesval);
  }

  chopFirstChar(str) {
    return str.substr(1);
  }

  fetchfilteredProductNames(value) {
    if (this.isSearchAPIEnabled()) {
      this.apiSearch(value);
    } else {
      this.localSearch(value);
    }
  }

  localSearch(value) {
    this.filteredProductNames = [];
    if (value.length <= 2) {
      this.isSearchListHidden = true;
      return;
    }
    let filteredData = [];
    if (this.isNumeric(value)) {
      filteredData = this.availableProductIds;
    } else {
      filteredData = this.availableProductNames;
    }

    this.filteredProductNames = _.filter(filteredData, tmp => {
      let isValid = false;
      try {
        isValid = tmp.search(new RegExp(value, "i")) > -1;
      } catch (e) {
        //Do not do anything
      }
      return isValid;
    });
    this.selectedProductIdx = 0;
    this.isSearchListHidden = false;
  }

  apiSearch(value) {
    this.searchService
      .getSuggestions(value, this.listId, this.appliedFilter)
      .then(res => {
        this.filteredProductNames = res.items;
        this.searchConfiguredFields = res.searchFields;
        this.selectedProductIdx = 0;
        this.isSearchListHidden = false;
      });
  }

  isSearchAPIEnabled() {
    return this.ENV && this.ENV["api_search_enabled"] ? true : false;
  }

  onSearchKeyChange(event) {
    if (event.keyCode === 13 && this.filteredProductNames.length > 0) {
      this.gotoSelected();
    } else if (event.keyCode === 40 && this.filteredProductNames.length > 0) {
      this.goDown();
    } else if (event.keyCode === 38 && this.filteredProductNames.length > 0) {
      this.goUp();
    } else {
      this.fetchfilteredProductNames(event.target.value);
    }
  }

  goDown() {
    this.selectedProductIdx = this.selectedProductIdx + 1;
    if (this.selectedProductIdx >= this.filteredProductNames.length) {
      this.selectedProductIdx = 0;
    }
  }

  goUp() {
    this.selectedProductIdx = this.selectedProductIdx - 1;
    if (this.selectedProductIdx < 0) {
      this.selectedProductIdx = this.filteredProductNames.length - 1;
    }
  }

  gotoSelected() {
    this.goto(this.filteredProductNames[this.selectedProductIdx]);
    this.bgOpacity = false;
  }

  goto(product) {
    if (this.isSearchAPIEnabled()) {
      this.applyAPIFilter(product);
    } else {
      this.applyLocalProduct(product);
    }
    this.inputSearchValue = "";
    this.isSearchHidden = true;
    this.isSearchListHidden = true;
    this.filteredProductNames = [];
    this.selectedProductIdx = 0;
  }

  applyAPIFilter(product) {
    this.searchProduct.emit({
      obj: product,
      fields: this.searchConfiguredFields
    });
  }

  applyLocalProduct(product) {
    let underscoreCase = "";
    if (this.isNumeric(product)) {
      let productId = product.trim().replace(/ /g, "");
      if ($("#product-color-" + productId).length > 0) {
        $("html, body").animate({
          scrollTop: $("#product-color-" + productId).offset().top - 120
        });

        // $("#product-color-" + product).click();
      }
    } else {
      if (product) {
        let styleName = product.split("-")[0];
        let asrtName = product.split("-")[1];
        underscoreCase = styleName
          .trim()
          .toLowerCase()
          .replace(/ /g, "_");
        //Escape the jquery special characters like :.[],=@#, etc..
        asrtName = asrtName.toLowerCase().replace(/ /g, "_");
        underscoreCase =
          underscoreCase.replace(/(:|\.|\[|\]|,|=|@|#)/g, "\\$1") + asrtName;
      }
      if ($("#product-" + underscoreCase).length > 0) {
        $("html, body").animate({
          scrollTop:
            $("#product-" + underscoreCase).position().top -
            this.asrtHeaderHeight +
            1 +
            50
        });
      }
    }
  }

  onSelectedProductClick(idx) {
    this.selectedProductIdx = idx;
    this.gotoSelected();
    this.bgOpacity = false;
  }

  showSearchBar() {
    this.isSearchHidden = false;
    this.bgOpacity = true;
    $(document).on("keyup", this.clickEscButton.bind(this));
  }

  hideSearchBar() {
    this.isSearchHidden = true;
    this.bgOpacity = false;
  }

  clickEscButton(e) {
    if (e.keyCode == 27) {
      this.isSearchHidden = true;
      this.bgOpacity = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts